import React from 'react';
import { company } from '../data/company';
export function Footer() {
  return <footer className="bg-ink-950 pb-24 pt-14 text-sm text-ink-500 lg:pb-14" data-id="element-97" data-mp="3gezcj1s77n03">
      <div className="mx-auto max-w-content px-5 lg:px-8" data-id="element-98" data-mp="3gh3qkcjta2e3">
        <div className="grid gap-8 border-b border-ink-800 pb-10 sm:grid-cols-3" data-id="element-99" data-mp="32p5mwh8vcypb">
          <div data-id="element-100" data-mp="36ooajks2rnvu">
            <p className="font-display text-base font-bold uppercase tracking-tight text-bone" data-id="element-101" data-mp="36q94p9ah94t6">
              {company.owner}
            </p>
            <p className="mt-2" data-id="element-102" data-mp="3ud7ifz77pyne">{company.trade} — Maisons-Laffitte (78)</p>
          </div>
          <div data-id="element-103" data-mp="36mrefh5qqqd">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brass-light" data-id="element-104" data-mp="3lec9ifcsaage">
              Coordonnées
            </p>
            <p className="mt-2" data-id="element-105" data-mp="3qcdu54puyhtz">
              {company.address}
              <br data-id="element-106" data-mp="29zgkq0kfasm4" />
              {company.postalCode} {company.city}
              <br data-id="element-107" data-mp="2a19sxkaopkw8" />
              <a href={company.phoneHref} className="hover:text-bone" data-id="element-108" data-mp="2ey9yzv7jannc">
                {company.phone}
              </a>
            </p>
          </div>
          <div data-id="element-109" data-mp="3labrlvxno6qd">
            <p className="text-xs font-semibold uppercase tracking-[0.12em] text-brass-light" data-id="element-110" data-mp="3l9sk795mt0ql">
              Mentions légales
            </p>
            <p className="mt-2" data-id="element-111" data-mp="3v7ggw4mssibe">
              Entreprise individuelle
              <br data-id="element-112" data-mp="3v5n8okwjdq1a" />
              SIREN {company.siren}
              <br data-id="element-113" data-mp="3q7llbns2v4k0" />
              Assurance RC professionnelle à jour
            </p>
          </div>
        </div>
        <p className="pt-6 text-xs" data-id="element-114" data-mp="81foxu0vmo35">
          © {new Date().getFullYear()} {company.owner} — Serrurerie, dépannage et blindage en
          Île-de-France. Devis gratuit, aucun démarchage téléphonique.
        </p>
      </div>
    </footer>;
}